import { IconAlertTriangle, IconCircleCheck } from "@tabler/icons-react";
import { HintValidInvalid } from "./hint-valid-invalid";

const Field = ({
    label,
    missingLabels,
    isRequired,
}: {
    label: string;
    missingLabels: string[];
    isRequired?: boolean;
}) => {
    const isMissing = missingLabels.includes(label);

    if (!isMissing) {
        return (
            <>
                <IconCircleCheck
                    className="text-success"
                    stroke={1.5}
                    size={20}
                />
                {label}
            </>
        );
    }

    if (isRequired) {
        return (
            <>
                <IconAlertTriangle
                    className="text-danger"
                    stroke={1.5}
                    size={20}
                />
                {label}
            </>
        );
    }

    return (
        <>
            <IconAlertTriangle
                className="text-warning"
                stroke={1.5}
                size={20}
            />
            {label}
        </>
    );
};

export const HintFields = ({
    missingFieldLabels,
    requiredFields,
    optionalFields,
}: {
    missingFieldLabels?: string[];
    requiredFields: string[];
    optionalFields: string[];
}) => (
    <div className="flex flex-col gap-5">
        {requiredFields.length > 0 && (
            <div>
                <HintValidInvalid title="Pflichtfelder" />
                <ul className="inside space-y-0.5 py-2 ps-3 text-sm">
                    {requiredFields.map((label) => (
                        <li key={label} className="flex items-center gap-2">
                            <Field
                                label={label}
                                missingLabels={missingFieldLabels}
                                isRequired={true}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        )}
        {optionalFields.length > 0 && (
            <div>
                <HintValidInvalid title="Optionale Felder" />
                <ul className="inside list-disc space-y-0.5 py-2 ps-3 text-sm">
                    {optionalFields.map((label) => (
                        <li key={label} className="flex items-center gap-2">
                            <Field
                                label={label}
                                missingLabels={missingFieldLabels}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        )}
    </div>
);
